import React from "react";

const DashboardTabItem = ({ name, widgetCount = 0, isActive, isDefault, onClick, onDelete }) => {
  const handleDelete = e => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <div
      className={`dashboardV2Tab${isActive ? " dashboardV2TabActive" : ""}`}
      onClick={onClick}
      role="tab"
    >
      <span>{name}</span>
      <span className="dashboardV2TabWidgetCount">{widgetCount}</span>
      {!isDefault && (
        <button
          type="button"
          className="dashboardV2TabDeleteBtn"
          onClick={handleDelete}
          title="Delete dashboard"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default DashboardTabItem;
